import { callGetApi, callPostApi, callPutApi } from "api/ApiCaller";
import {
  Edit_UserAdmin_List_Item_PUT,
  Get_UserAdmin_List_Item_GET,
  Save_UserAdmin_List_Item_POST,
} from "api/ApiConst";
import { API_SUCCESS } from "api/ResponseCodes";
import ImageSelector from "components/common/ImageSelector";
import ModalWrapper from "components/common/ModalWrapper";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { MODAL_LOADER } from "utils/constants";
import dateUtilities from "utils/DateUtilities";
import { getDOB, getTimeFromDate, isEmpty } from "utils/TextUtils";

const UserAdminAddEdit = ({ show, hideModal, recordID, handleRefresh }) => {
  const [record, setRecord] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    dateOfBirthTimeStamp: 0,
    isdCode: "+91",
    mobile: "",
    email: "",
    username: "",
    password: "",
    photoImageRefId: "",
  });

  const checkInputValidation = () => {
    if (isEmpty(record.photoImageRefId)) {
      toast.error("Image must not be empty.", {
        id: "photoImageRefId",
      });
      return;
    } else if (isEmpty(record.firstName)) {
      toast.error("First Name must not be empty.", {
        id: "firstName",
      });
      return;
    } else if (isEmpty(record.lastName)) {
      toast.error("Last Name must not be empty.", {
        id: "lastName",
      });
      return;
    } else if (isEmpty(record.dateOfBirthTimeStamp)) {
      toast.error("Date of birth must not be empty.", {
        id: "dateOfBirthTimeStamp",
      });
      return;
    } else if (isEmpty(record.gender)) {
      toast.error("Gender must not be empty.", {
        id: "dateOfBirthTimeStamp",
      });
      return;
    } else if (isEmpty(record.isdCode)) {
      toast.error("ISD Code must not be empty.", {
        id: "isdCode",
      });
      return;
    } else if (isEmpty(record.mobile)) {
      toast.error("Mobile Number must not be empty.", {
        id: "mobile",
      });
      return;
    } else if (isEmpty(record.email)) {
      toast.error("Email must not be empty.", {
        id: "email",
      });
      return;
    } else if (isEmpty(record.username)) {
      toast.error("Username must not be empty.", {
        id: "username",
      });
      return;
    } else if (isEmpty(record.password)) {
      toast.error("Password must not be empty.", {
        id: "password",
      });
      return;
    }
    return true;
  };

  const handleSubmit = () => {
    try {
      if (!checkInputValidation()) {
        return;
      }

      const recordObj = {
        ...record,
        dateOfBirthTimeStamp: getTimeFromDate(record.dateOfBirthTimeStamp),
      };

      if (recordID) {
        // update
        callPutApi(
          MODAL_LOADER,
          Edit_UserAdmin_List_Item_PUT.replace("{uuid}", recordID),
          recordObj,
          {},
          (res) => {
            if (res.errorCode === API_SUCCESS) {
              hideModal(false);
              handleRefresh();
            }
          }
        );
      } else {
        // Create
        callPostApi(
          MODAL_LOADER,
          Save_UserAdmin_List_Item_POST,
          recordObj,
          (res) => {
            if (res.errorCode === API_SUCCESS) {
              hideModal(false);
              handleRefresh();
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    recordID &&
      callGetApi(
        MODAL_LOADER,
        Get_UserAdmin_List_Item_GET.replace("{uuid}", recordID),
        {},
        (response) => {
          const res = response.responsePacket;
          setRecord({
            firstName: res.firstName,
            lastName: res.lastName,
            gender: res.gender,
            dateOfBirthTimeStamp: getDOB(res.dateOfBirthTimeStamp),
            isdCode: res.isdCode,
            mobile: res.mobile,
            email: res.email,
            username: res.username,
            password: res.password,
            photoImageRefId: res.photoImageRefId,
          });
        }
      );
  }, [recordID]);

  const handleGameIconChange = (imageRefId) => {
    setRecord({ ...record, photoImageRefId: imageRefId });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobile") {
      if (value.length > 10) {
        return;
      }
    }
    setRecord({ ...record, [name]: value });
  };
  return (
    <>
      <ModalWrapper
        show={show}
        hide={hideModal}
        header={`${recordID ? "Update" : "Add"}`}
        handleSubmit={handleSubmit}
      >
        <div className="container">
          <div className="row">
            <div className="mb-3 col-12">
              <ImageSelector
                style={{
                  height: "120px",
                  width: "120px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  margin: "0 auto",
                }}
                user={true}
                handleImageChange={handleGameIconChange}
                selectedImage={record.photoImageRefId}
              />
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="firstName" className="form-label">
                First Name
              </label>
              <input
                type="text"
                className="form-control"
                value={record.firstName}
                name="firstName"
                onChange={(e) => handleInputChange(e)}
              ></input>
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="lastName" className="form-label">
                Last Name
              </label>
              <input
                type="text"
                className="form-control"
                value={record.lastName}
                name="lastName"
                onChange={(e) => handleInputChange(e)}
              ></input>
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="dob" className="form-label">
                Date Of Birth
              </label>
              <input
                type="date"
                className="form-control"
                value={record?.dateOfBirthTimeStamp}
                name="dateOfBirthTimeStamp"
                onChange={(e) => handleInputChange(e)}
              ></input>
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="gender" className="form-label">
                Gender
              </label>
              <span className="d-flex justify-content-between align-items-center">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="gender"
                    id="male"
                    value="Male"
                    onChange={(e) => handleInputChange(e)}
                    checked={"Male" === record.gender}
                  />
                  <label className="form-check-label" htmlFor="male">
                    Male
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="gender"
                    id="female"
                    value="Female"
                    onChange={(e) => handleInputChange(e)}
                    checked={"Female" === record.gender}
                  />
                  <label className="form-check-label" htmlFor="female">
                    Female
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="gender"
                    id="other"
                    value="Other"
                    onChange={(e) => handleInputChange(e)}
                    checked={"Other" === record.gender}
                  />
                  <label className="form-check-label" htmlFor="other">
                    Other
                  </label>
                </div>
              </span>
            </div>
            <div className="col-lg-6 mb-3">
              <div className="row">
                <div className="col-4">
                  <label htmlFor="isdCode" className="form-label">
                    ISD Code
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={record.isdCode}
                    name="isdCode"
                    onChange={(e) => handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-8">
                  <label htmlFor="" className="form-label">
                    Mobile
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={record.mobile}
                    name="mobile"
                    onChange={(e) => handleInputChange(e)}
                  ></input>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="firstName" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                value={record.email}
                name="email"
                onChange={(e) => handleInputChange(e)}
              ></input>
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="firstName" className="form-label">
                Username
              </label>
              <input
                type="text"
                className="form-control"
                value={record.username}
                name="username"
                onChange={(e) => handleInputChange(e)}
              ></input>
            </div>
            {!recordID && (
              <div className="col-lg-6 mb-3">
                <label htmlFor="firstName" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  value={record.password}
                  name="password"
                  onChange={(e) => handleInputChange(e)}
                ></input>
              </div>
            )}
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};

export default UserAdminAddEdit;
